"use client"
import { useState, useEffect } from "react";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";
import { X } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import { LIVE_ROOM_CACHE_KEY } from '@/app/const/locale';
import { useUserInfo } from '@/app/stores/useUserStore';

export default function CoLivePopover() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const userInfo = useUserInfo();
    const [isShow, setIsShow] = useState(false);
    const [liveRoom, setLiveRoom] = useState<any>(null);

    useEffect(() => {
        if (userInfo?.userId) {
            const liveRoomData = sessionStorage.getItem(LIVE_ROOM_CACHE_KEY + userInfo?.userId);
            if (liveRoomData) {
                setLiveRoom(JSON.parse(liveRoomData));
                setIsShow(true);
            }
            else {
                setIsShow(false);
            }
        }
        else {
            setIsShow(false);
        }
    }, [userInfo?.userId]);
    if (!isShow) {
        return null;
    }
    return (
        <div className="fixed bottom-14 right-2 flex items-center gap-1 z-[50] rounded-full shadow-lg group bg-gradient-to-r from-primary-500 to-primary-500 via-primary-500 cursor-pointer"  onClick={() => {
            navigate(`/live/detail?id=${liveRoom?.roomId}`)
        }}>
            <div className="w-14 h-14 absolute left-0 top-0 z-10">
                <span className="text-xs absolute -bottom-2 left-1/2 -translate-x-1/2 p-1 bg-primary-500 text-center rounded-full scale-75 border border-white min-w-full text-font-reverse font-bold">{t('livePopover.watching')}</span>
            </div>
            <div className="h-14 max-w-14 group-hover:max-w-80 flex items-center gap-1 overflow-hidden transition-all duration-200 p-1 z-9 relative">
                <Avatar className="w-12 h-12 border animate-spin-slow">
                    <AvatarImage
                        src={liveRoom?.avatar}
                        alt={liveRoom.userName}
                    />
                    <AvatarFallback className="text-xs" delayMs={600}>
                        {liveRoom?.userName?.charAt(0)}
                    </AvatarFallback>
                </Avatar>
                <div className="flex flex-col flex-1 gap-0.5">
                    <span className="text-sm text-font-reverse font-bold text-ellipsis overflow-hidden line-clamp-1 break-all">{liveRoom?.userName}</span>
                    <span className="text-xs text-font-reverse/90 text-ellipsis overflow-hidden  line-clamp-1 break-all">{liveRoom?.roomName}</span>
                </div>
                <div className="flex items-center gap-1.5 mx-2 ml-4">
                    {/* <Tooltip title={t('livePopover.returnToLive')}>
                        <div className="size-6 flex items-center justify-center rounded-sm hover:bg-white/40 transition-all duration-200 cursor-pointer text-black cursor-pointer">
                            <MoveDiagonal className="size-5" onClick={() => {
                                navigate(`/live/detail?id=${liveRoom?.roomId}`)
                            }} />
                        </div>
                    </Tooltip> */}
                    <Tooltip title={'关闭'}>
                        <div className="size-6 flex items-center justify-center rounded-sm hover:bg-white/40 transition-all duration-200 cursor-pointer text-font-reverse cursor-pointer">
                            <X className="size-4" onClick={(e) => {
                                e.preventDefault()
                                e.stopPropagation()
                                sessionStorage.removeItem(LIVE_ROOM_CACHE_KEY + userInfo?.userId);
                                setIsShow(false);
                            }} />
                        </div>

                    </Tooltip>
                </div>
            </div>
        </div>
    )
}
